import { AppBar, Box, Button, Container, Toolbar, Tooltip, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link as RouterLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';

export function AppLayout() {
  const { user, clearSession } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearSession();
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            AI Maturity Model
          </Typography>
          {user && (
            <>
              <Button
                color="inherit"
                component={RouterLink}
                to="/dashboard"
                sx={{ textTransform: 'uppercase' }}
              >
                DASHBOARD
              </Button>
              <Button
                color="inherit"
                component={RouterLink}
                to="/assessment"
                sx={{ textTransform: 'uppercase' }}
              >
                TAKE ASSESSMENT
              </Button>
              <Typography variant="body2" sx={{ ml: 2, mr: 1 }}>
                {user.email}
              </Typography>
              <Tooltip title="Log Out">
                <Button
                  color="inherit"
                  onClick={handleLogout}
                  startIcon={<LogoutIcon aria-hidden="true" />}
                  aria-label="Log Out"
                  sx={{ textTransform: 'uppercase' }}
                >
                  LOG OUT
                </Button>
              </Tooltip>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Container component="main" sx={{ flex: 1, py: 4 }}>
        <Outlet />
      </Container>
    </Box>
  );
}
